import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Card, Label, Loader } from 'semantic-ui-react';

import {
  compose,
} from 'recompose';

import hasUserInfo from '../../hocs/has-user-info';
import hasRestClient from '../../hocs/has-rest-client';

const wrapperStyle = {
  display: 'block',
  minHeight: 50,
};

class TagCloud extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      tags: [],
    };
  }

  async componentDidMount() {
    const response = await this.loadTags();
    const tags = _.get(response, 'data.data');
    this.setState({
      tags,
      isLoading: false,
    });
  }

  loadTags = async () => {
    const { userInfo: { organisationId }, restClient } = this.props;
    return restClient.get(`tags?filter[organisation]=${organisationId}`);
  }

  render() {
    const { isLoading, tags } = this.state;
    const { onTagSelected } = this.props;
    return (
      <Card fluid>
        <Card.Content>
          <h3>Influencer tags</h3>
        </Card.Content>
        <Card.Content style={wrapperStyle}>
          {
            isLoading && <Loader inline="centered" active />
          }
          <Label.Group size="huge">
            {
              _.map(tags, tag => <Label
                onClick={() => onTagSelected(_.get(tag, 'id'))}
                key={_.get(tag, 'id')}
              >
                {_.get(tag, 'attributes.value')}
              </Label>)
            }
          </Label.Group>
        </Card.Content>
      </Card>
    );
  }
}

TagCloud.propTypes = {
  onTagSelected: PropTypes.func.isRequired,
};

export default compose(
  hasUserInfo,
  hasRestClient,
)(TagCloud);



/** WEBPACK FOOTER **
 ** ./src/containers/tag-cloud/index.js
 **/